module.exports = __webpack_public_path__ + "static/media/robot-dev.82096f1a.png";